export const flowchartVersionsQueryKey = (cycleId, processId, auditYearId) => [
  'flowchart-versions',
  cycleId,
  processId,
  auditYearId ?? ''
];

export const flowchartQueryKeys = {
  versions: {
    list: flowchartVersionsQueryKey
  }
};
